import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {Group} from '../../graphql/groups.datatypes';
import {gqlGroup} from './getGroup.api';

interface GroupByRefData {
    group: void
    groupByRef: Group
}

export const GET_GROUP_QUERY = gql`
    query getGroupByRef($booking_form_url: String!){
        groupByRef(booking_form_url: $booking_form_url){
          ${gqlGroup}
        }
    }
`;

export const getGroupByRef = (groupRef: string) => {
    return useQuery<GroupByRefData>(
        GET_GROUP_QUERY,
        {
            variables: {booking_form_url: groupRef}
        }
    );
};

export default getGroupByRef;